const ScriptEnums = {
  profileKeys: {
    SCRIPTS: 'scripts',
    SCRIPT_TEMPLATES: 'script_templates',
    DISCHEMS: 'dischems',
    PATIENT_MEDICATIONS: 'patient_medications'
  },
  routeKeys: {
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    COUNT: 'count',
    AGGREGATE: 'aggregate',
    BULK_WRITE: 'bulk_write'
  }
}

export default ScriptEnums
